
import { useGoogleAuth } from './useGoogleAuth';
import { useEmailAuth } from './useEmailAuth';
import { useAuthListener } from './useAuthListener';

// Combined hook that provides all auth functionality
export const useAuthActions = () => {
  const { loading: googleLoading, error: googleError, setError: setGoogleError, handleGoogleLogin } = useGoogleAuth();
  const { loading: emailLoading, error: emailError, setError: setEmailError, handleEmailAuth } = useEmailAuth();
  const { isChecking, setupAuthListener } = useAuthListener();

  // Combine loading states
  const loading = googleLoading || emailLoading || isChecking;
  
  // Combine error states, prioritizing the most recent error
  const error = emailError || googleError || null;
  
  // Function to reset errors
  const setError = (errorMessage: string | null) => {
    setGoogleError(null);
    setEmailError(errorMessage);
  };

  return {
    loading,
    error,
    setError,
    handleGoogleLogin,
    handleEmailAuth,
    setupAuthListener
  };
};

// Export individual hooks for more granular usage
export { useGoogleAuth, useEmailAuth, useAuthListener };
